import styled from 'styled-components';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';
import { paddingBuilder, themeSpace } from 'styles/themeUtils';

const HeaderBlock = styled(Block)`
  ${paddingBuilder.all(0)}
  margin-bottom: ${themeSpace(3.5)};

  ${tablet768`
    ${paddingBuilder.all(0)}
    align-self: flex-start;
  `}
`;

HeaderBlock.displayName = 'HeaderBlock';

export default HeaderBlock;
